module.exports = __webpack_public_path__ + "media/images/social-icons/twitter-white-c03f91c02f2bf1cc387c60b3d72d23c4.svg";